import { render } from "./SoilExamination.vue?vue&type=template&id=387d702d"
import script from "./SoilExamination.vue?vue&type=script&lang=js"
export * from "./SoilExamination.vue?vue&type=script&lang=js"

import "./SoilExamination.vue?vue&type=style&index=0&id=387d702d&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__